import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.less";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import Router from "./routers";
import store from "./store";
// if (process.env.NODE_ENV === 'development') {
//     import('./mocks/index')
// }
ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN}>
      <Router />
    </ConfigProvider>
  </Provider>,
  document.getElementById("root"),
);
const m: any = module;
if (m.hot) {
  m.hot.accept();
}
